import { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Sheet } from '@/components/ui/dialog'
import { useMediaQuery } from '@/hooks/useMediaQuery'
import { routeTrail } from '@/lib/route-trail'
import { cn } from '@/lib/utils'
import { useUIStore } from '@/store/ui'
import Sidebar from './Sidebar'
import TopBar from './TopBar'

export default function AppShell() {
  const { sidebarOpen } = useUIStore()
  const location = useLocation()
  const isLgUp = useMediaQuery('(min-width: 1024px)')
  const [drawerOpen, setDrawerOpen] = useState(false)

  useEffect(() => {
    if (isLgUp) setDrawerOpen(false)
  }, [isLgUp])

  useEffect(() => {
    setDrawerOpen(false)
  }, [location.pathname])

  useEffect(() => {
    // Every path inside the shell is a known route or the 404 page.
    const page = routeTrail(location.pathname).at(-1) ?? 'Page not found'
    document.title = `${page} · EsaFX Backoffice`
  }, [location.pathname])

  return (
    <div className="flex min-h-screen max-lg:min-h-[100dvh] overflow-x-clip bg-background">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[60] focus:rounded-lg focus:bg-primary focus:px-3 focus:py-2 focus:text-sm focus:text-primary-foreground"
      >
        Skip to content
      </a>
      <Sidebar />
      {/* Native dialog sheet: focus trap, Escape and focus restore come with it. */}
      <Sheet open={!isLgUp && drawerOpen} onClose={() => setDrawerOpen(false)} side="left" label="Menu" className="w-70 max-w-[calc(100vw-2.5rem)] sm:w-70" contentClassName="h-dvh p-0">
        <Sidebar variant="drawer" onNavigate={() => setDrawerOpen(false)} />
      </Sheet>
      {/* overflow-x-clip, not hidden: hidden makes a scroll box and the sticky glass bars stop sticking. */}
      <div className={cn('flex min-w-0 flex-1 flex-col overflow-x-clip transition-[margin] duration-200 ease-out motion-reduce:transition-none', sidebarOpen ? 'lg:ml-70' : 'lg:ml-16')}>
        <TopBar showMenu={!isLgUp} onMenuClick={() => setDrawerOpen(true)} />
        <main id="main" tabIndex={-1} className="min-w-0 flex-1 overflow-x-clip px-4 pt-5 pb-8 outline-none lg:px-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
